export default "__VITE_ASSET__CDZLJ3It__"